import { IMarker } from "redux/utils/interfaces";
import { reduxActionType } from "redux/utils/types";

export const setMapData = (payload: {stations:IMarker[]}): reduxActionType => {
	return {
		type: "SET_MAP_DATA",
		payload,
	};
};

export const setStationId = (payload: {stations:string}): reduxActionType => {
	return {
		type: "SET_StationId",
		payload,
	};
};

export const setStationIndex = (payload: {stations:number}): reduxActionType => {
	return {
		type: "SET_StationIndex",
		payload,
	};
};

